import { FormGroup } from '@angular/forms';
import { Observable, of, ObservableInput, combineLatest, BehaviorSubject } from 'rxjs';
import { tap, switchMap, map, startWith, pairwise, filter } from 'rxjs/operators';


export function tapOnce<T>(callback: () => void) {
	let tapped = false;
	return (source: Observable<T>) => of({}).pipe(
		tap(_ => {
			if (!tapped) {
				callback();
				tapped = true;
			}
		}),
		switchMap(_ => source)
	);
}

export function combineEither<R>(...observables: ObservableInput<any>[]): Observable<R> {
	return combineLatest(observables).pipe(
		map(ors => ors.find(Boolean))
	)
}

export function asBehaviorSubject<T>(observable: Observable<T>, initValue: T): BehaviorSubject<T> {
	const subject = new BehaviorSubject(initValue);

	observable.subscribe({
		complete: () => subject.complete(),
		error: x => subject.error(x),
		next: x => subject.next(x)
	});

	return subject;
}

export function formValueChanges(form: FormGroup) {
	const changes$ = form.valueChanges.pipe(
		startWith({}),
		pairwise(),
		map(([v1, v2]) => Object.keys(v2).reduce((acc, k) => ({ ...acc, [k]: v1[k] !== v2[k] }), {}))
	)
	return {
		include: (...fields: string[]) => changes$.pipe(
			map(changes => fields.filter(f => changes[f])),
			filter(cs => cs.length > 0),
			map(fields => ({ fields, value: form.value}))
		),
		exclude: (...fields: string[]) => changes$.pipe(
			map(changes => Object.keys(changes).filter(f => changes[f] && !fields.includes(f))),
			filter(cs => cs.length > 0),
			map(fields => ({ fields, value: form.value}))
		),
	}
}
